import { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import DashboardHeader from "../../Components/DashboardHeader/DashboardHeader";
import { toast } from "react-toastify";

export default function CreateProduct() {
  const navigate = useNavigate();
  const [inputs, setInputs] = useState({});
  const [file, setFile] = useState(null); 

  const handleChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    setInputs((values) => ({ ...values, [name]: value }));
  };

  const handleFileChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      setFile(event.target.files[0]);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const formData = new FormData();
    Object.keys(inputs).forEach((key) => {
      formData.append(key, inputs[key]);
    });
    if (file) {
      formData.append("image", file);
    }


    try {
      const response = await axios.post(
        "https://www.tanura.az/tanura/dashboard.php/save",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      console.log(formData)
      navigate("/dashboard");
      toast("Yeni məhsul əlavə olundu")
    } catch (error) {
      console.error("Error while saving the product:", error);
    }
  };

  return (
    <>
      <DashboardHeader />
      <div className="max-w-containerSm md:max-w-container py-20 mx-auto">
        <form className="bg-white" onSubmit={handleSubmit}>
          <table cellSpacing="10">
            <tbody>
              <tr>
                <th>
                  <label>Ad: </label>
                </th>
                <td>
                  <input
                    type="text"
                    name="name"
                    onChange={handleChange}
                  />
                </td>
              </tr>
              <tr>
                <th>
                  <label>Kateqoriya </label>
                </th>
                <td>
                  <select
                    name="category1"
                    onChange={handleChange}
                  >
                    <option value="">Seçin</option>
                    <option value="ev">Ev qulluq məhsulları</option>
                    <option value="kabin">Professional baxım məhsulları</option>
                    <option value="set">Set məhsulları</option>
                  </select>
                </td>
              </tr>
              <tr>
                <th>
                  <label>Alt Kateqoriya </label>
                </th>
                <td>
                  <select
                    name="category2"
                    onChange={handleChange}
                  >
                    <option value="">Seçin</option>
                    <option value="Saç">Saç</option>
                    <option value="Bədən">Bədən</option>
                    <option value="Üz">Üz</option>
                  </select>
                </td>
              </tr>
              <tr>
                <th>
                  <label>Dəri tipinə görə </label>
                </th>
                <td>
                  <select
                    name="category3"
                    onChange={handleChange}
                  >
                    <option value="">Seçin</option>
                    <option value="Bütün">Bütün</option>
                    <option value="Həssas">Həssas</option>
                    <option value="Qarışıq və yağlı">Qarışıq və yağlı</option>
                    <option value="Quru və normal">Quru və normal</option>
                    <option value="Səpkili">Səpkili</option>
                  </select>
                </td>
              </tr>
              <tr>
                <th>
                  <label>Təsvir: </label>
                </th>
                <td>
                  <input
                    type="text"
                    name="description"
                    onChange={handleChange}
                  />
                </td>
              </tr>
              <tr>
                <th>
                  <label>İstifadəsi: </label>
                </th>
                <td>
                  <input
                    type="text"
                    name="useful"
                    onChange={handleChange}
                  />
                </td>
              </tr>
              <tr>
                <th>
                  <label>Tərkib 1: </label>
                </th>
                <td>
                  <input
                    type="text"
                    name="composition1"
                    onChange={handleChange}
                  />
                </td>
              </tr>
              <tr>
                <th>
                  <label>Tərkib 2: </label>
                </th>
                <td>
                  <input
                    type="text"
                    name="composition2"
                    onChange={handleChange}
                  />
                </td>
              </tr>
              <tr>
                <th>
                  <label>Tərkib 3: </label>
                </th>
                <td>
                  <input
                    type="text"
                    name="composition3"
                    onChange={handleChange}
                  />
                </td>
              </tr>
              <tr>
                <th>
                  <label>Tərkib 4: </label>
                </th>
                <td>
                  <input
                    type="text"
                    name="composition4"
                    onChange={handleChange}
                  />
                </td>
              </tr>
              <tr>
                <th>
                  <label>Tərkib 5: </label>
                </th>
                <td>
                  <input
                    type="text"
                    name="composition5"
                    onChange={handleChange}
                  />
                </td>
              </tr>
              <tr>
                <th>
                  <label>Tərkib 6: </label>
                </th>
                <td>
                  <input
                    type="text"
                    name="composition6"
                    onChange={handleChange}
                  />
                </td>
              </tr>
              <tr>
                <th>
                  <label>Tərkib 7: </label>
                </th>
                <td>
                  <input
                    type="text"
                    name="composition7"
                    onChange={handleChange}
                  />
                </td>
              </tr>
              <tr>
                <th>
                  <label>Tərkib 8: </label>
                </th>
                <td>
                  <input
                    type="text"
                    name="composition8"
                    onChange={handleChange}
                  />
                </td>
              </tr>
              <tr>
                <th>
                  <label>Tərkib 9: </label>
                </th>
                <td>
                  <input
                    type="text"
                    name="composition9"
                    onChange={handleChange}
                  />
                </td>
              </tr>
              <tr>
                <th>
                  <label>Tərkib 10: </label>
                </th>
                <td>
                  <input
                    type="text"
                    name="composition10"
                    onChange={handleChange}
                  />
                </td>
              </tr>
              <tr>
                <th>
                  <label>Xüsusiyyət 1: </label>
                </th>
                <td>
                  <input
                    type="text"
                    name="setting1"
                    onChange={handleChange}
                  />
                </td>
              </tr>
              <tr>
                <th>
                  <label>Cavab 1: </label>
                </th>
                <td>
                  <input
                    type="text"
                    name="answer1"
                    onChange={handleChange}
                  />
                </td>
              </tr>
              <tr>
                <th>
                  <label>Xüsusiyyət 2: </label>
                </th>
                <td>
                  <input
                    type="text"
                    name="setting2"
                    onChange={handleChange}
                  />
                </td>
              </tr>
              <tr>
                <th>
                  <label>Cavab 2: </label>
                </th>
                <td>
                  <input
                    type="text"
                    name="answer2"
                    onChange={handleChange}
                  />
                </td>
              </tr>
              <tr>
                <th>
                  <label>Xüsusiyyət 3: </label>
                </th>
                <td>
                  <input
                    type="text"
                    name="setting3"
                    onChange={handleChange}
                  />
                </td>
              </tr>
              <tr>
                <th>
                  <label>Cavab 3: </label>
                </th>
                <td>
                  <input
                    type="text"
                    name="answer3"
                    onChange={handleChange}
                  />
                </td>
              </tr>
              <tr>
                <th>
                  <label>Xüsusiyyət 4: </label>
                </th>
                <td>
                  <input
                    type="text"
                    name="setting4"
                    onChange={handleChange}
                  />
                </td>
              </tr>
              <tr>
                <th>
                  <label>Cavab 4: </label>
                </th>
                <td>
                  <input
                    type="text"
                    name="answer4"
                    onChange={handleChange}
                  />
                </td>
              </tr>
              <tr>
                <th>
                  <label>Xüsusiyyət 5: </label>
                </th>
                <td>
                  <input
                    type="text"
                    name="setting5"
                    onChange={handleChange}
                  />
                </td>
              </tr>
              <tr>
                <th>
                  <label>Cavab 5: </label>
                </th>
                <td>
                  <input
                    type="text"
                    name="answer5"
                    onChange={handleChange}
                  />
                </td>
              </tr>
              <tr>
                <th>
                  <label>Ən çox satılan: </label>
                </th>
                <td>
                  <select
                    name="bestseller"
                    onChange={handleChange}
                    required
                  >
                    <option value="">Seçin</option>
                    <option value="0">Xeyr</option>
                    <option value="1">Bəli</option>
                  </select>
                </td>
              </tr>
              <tr>
                <th>
                  <label>Şəkil: </label>
                </th>
                <td>
                  <input
                    type="file"
                    name="image"
                    accept="image/*"
                    onChange={handleFileChange}
                    required
                  />
                </td>
              </tr>
              <tr>
                <td colSpan="2" align="right">
                  <button
                    type="submit"
                    className="bg-[#223077] text-white px-6 sm:px-7 md:px-8 py-2 rounded-full"
                  >
                    Yadda saxla
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </form>
      </div>
    </>
  );
}
